define('modules/stats/views/listing_item',['require','exports','module','base/itemview','services/auth','ldsh!../templates/listing_item'],function (require, exports, module) {
  'use strict';

  var ItemView = require('base/itemview'),
    Auth = require('services/auth'),
    authInfo = Auth.getAuthInfo();

  module.exports = ItemView.extend({
    tagName: 'tr',
    template: require('ldsh!../templates/listing_item'),
    events: {},
    triggers: {},
    helpers: function () {
      var properties = JSON.parse(this.model.get('properties'));
      return {
        showItem: this.showItem(this.model.get('company_id')),
        company: this.model.get('company_name'),
        type: this.model.get('type'),
        max_visitors: properties.maxVisits,
        visitors: this.model.get('visits'),
        visits: this.model.get('impressions'),
        convert: this.model.get('conversion'),
        pages: this.model.get('num_pages'),
        domains: this.model.get('num_domains'),
      };
    },
    showItem: function (company_id) {
      return (
        authInfo.getCompanies() &&
        _.filter(authInfo.getCompanies(), function (company) {
          return company_id == company.id;
        }).length
      );
    },
  });
});

